import { routes } from "./Routes";

export const getPublicRoutes = () => {
  return routes.filter((item) => !item.config.isAuth);
};

export const getPrivateRoutes = () => {
  return routes.filter((item) => item.config.isAuth);
};
